import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      // Banner tones, re-declared as sonner's vars — the alpha fills are composited onto the toast surface so it stays opaque.
      toastOptions={{
        classNames: {
          success:
            '[--normal-bg:var(--color-brand-200)] [--normal-border:var(--color-brand-600)] [--normal-text:var(--color-brand-900)]',
          warning:
            '[--normal-bg:color-mix(in_oklab,var(--amber)_15%,var(--popover))] [--normal-border:color-mix(in_oklab,var(--amber)_40%,var(--popover))] [--normal-text:var(--amber-text)]',
          error:
            '[--normal-bg:color-mix(in_oklab,var(--color-error)_10%,var(--popover))] [--normal-border:color-mix(in_oklab,var(--color-error)_35%,var(--popover))] [--normal-text:var(--red-text)]',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
